import { create } from 'zustand';
import type { CurrentUser } from '../services/authService';

interface AuthState {
  user: CurrentUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: CurrentUser | null) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  setUser: (user) => set({
    user,
    isAuthenticated: !!user,
    isLoading: false
  }),

  setLoading: (loading) => set({ isLoading: loading }),

  clearAuth: () => set({
    user: null,
    isAuthenticated: false,
    isLoading: false
  }),
}));

export default useAuthStore;